import { Component, OnInit } from '@angular/core'
import { collection, collectionData, orderBy, query } from '@angular/fire/firestore'
import { FirestoreStructure, LogEmail } from '@parkupp/core'
import { AdminService } from '../../../services/admin.service'
import { LogEmailService } from 'src/app/services/log-email.service'

@Component({
    selector: 'app-list-email-by-subject-line',
    templateUrl: './list-email-by-subject-line.component.html',
    styleUrls: ['./list-email-by-subject-line.component.scss'],
})
export class ListEmailBySubjectLineComponent implements OnInit {
    logEmails: LogEmail[]

    constructor(private adminService: AdminService, private logEmailService: LogEmailService) {}

    async ngOnInit(): Promise<void> {
        this.logEmails = await this.logEmailService.getEmailsGroupedBySubject()
    }

    async onNeedsReview(logEmail: LogEmail): Promise<void> {
        logEmail.needsReview = !logEmail.needsReview
        await this.logEmailService.updateOverviewDoc(logEmail)
    }
}
